import React from 'react';
import { Box, Typography } from '@mui/material';

import IntlMessage from 'components/IntlMessage';

import { CategoryIcon, ContentHubIcon, ProductIcon, AccountIcon } from 'assets';

export const toolBarConfig = [
  {
    key: 'categories',
    label: (
      <Typography variant="h5">
        <IntlMessage id="product_introduce" />
      </Typography>
    ),
    icon: (
      <Box height="30px">
        <CategoryIcon width="1.6em" height="1.6em" />
      </Box>
    ),
    path: '/categories',
  },
  {
    key: 'content-category',
    label: (
      <Typography variant="h5">
        <IntlMessage id="content_hub" />
      </Typography>
    ),
    icon: (
      <Box height="30px">
        <ContentHubIcon width="1.6em" height="1.6em" />
      </Box>
    ),
    path: '/content-category/all',
  },
  {
    key: 'category',
    label: (
      <Typography variant="h5">
        <IntlMessage id="sample" />
      </Typography>
    ),
    icon: (
      <Box height="30px">
        <ProductIcon wwidth="1.6em" height="1.6em" />
      </Box>
    ),
    path: '/category/all',
  },
  {
    key: 'my-account',
    label: (
      <Typography variant="h5">
        <IntlMessage id="my_account" />
      </Typography>
    ),
    icon: (
      <Box height="30px">
        <AccountIcon wwidth="1.6em" height="1.6em" />
      </Box>
    ),
    path: '/my-account',
  },
];
